export default "__VITE_ASSET__CcupJr4P__"